import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import '@maersk-global/mds-components-core/mc-multi-select';
import '@maersk-global/mds-components-core-radio-group';
import '@maersk-global/mds-components-core-radio';
import '@maersk-global/mds-components-core/mc-button';
import { RepairModeFilterForm } from '../../../form-model/repair-mode-filter.form.model';
import { RepairModeService } from '../../../services/repair-mode.service';
import { CodeDescription } from '../../../models/code-description.model';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-repair-mode-advanced-filter',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './repair-mode-advanced-filter.component.html',
  styleUrl: './repair-mode-advanced-filter.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairModeAdvancedFilterComponent implements OnInit {
  @Input({ required: true }) repairModeFilterForm!: FormGroup<RepairModeFilterForm>;

  modeDescriptionList: CodeDescription[] = [];
  isLoadingModes = false;

  constructor(
    private readonly repairModeService: RepairModeService,
    private readonly formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.addControlsToFormGroup();
    this.loadFilterOptions();
  }

  private addControlsToFormGroup(): void {
    const form = this.repairModeFilterForm;
    if (!form.get('repairModeCodeList')) {
      form.addControl('repairModeCodeList', this.formBuilder.control<string[] | null>(null));
    }
    if (!form.get('activeStatusesList')) {
      form.addControl('activeStatusesList', this.formBuilder.control<string | null>(null));
    }
  }

  private async loadFilterOptions(): Promise<void> {
    this.isLoadingModes = true;
    try {
      this.modeDescriptionList = await firstValueFrom(this.repairModeService.getAllModeDescriptions());
    } catch {
      this.modeDescriptionList = [];
    } finally {
      this.isLoadingModes = false;
    }
  }

  applyFilters(): void {
    this.repairModeFilterForm.get('applyRepairModeFilter')?.setValue(true);
  }

  clearFilters(): void {
    this.repairModeFilterForm.patchValue({ repairModeCodeList: null, activeStatusesList: null });
    this.repairModeFilterForm.get('applyRepairModeFilter')?.setValue(true);
  }
}
